import { put, call, takeEvery } from 'typed-redux-saga';
import CustomerGateway from '~apis/customer';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { MetalTypeEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';

export default function* watchGetPendingReleaseEarmarkListing(api: CustomerGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalGetPendingReleaseEarmarkListingAttempt', handleGetPendingReleaseEarmarkListing, api);
}

function* handleGetPendingReleaseEarmarkListing(api: CustomerGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        index,
        filters: {
            dateFrom,
            dateTo,
            branchCode,
            customerId,
            customerName,
            status,
            metalType,
        },
    } = reduxState.approval.pendingReleaseEarmarkListing;

    if (!index && index !== 0) {
        yield put(combinedActions.approvalGetPendingReleaseEarmarkListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.getReleaseEarmarkListing], {
        authToken,
        index,
        dateFrom: dateFrom ? dateFrom : undefined,
        dateTo: dateTo ? dateTo : undefined,
        branchCode: branchCode ? branchCode : undefined,
        customerId: customerId ? customerId : undefined,
        customerName: customerName ? customerName : undefined,
        status: status ? status : undefined,
        metalType: metalType ? UtilFunctions.Misc.getEnumValueByKey(MetalTypeEnum, metalType) : undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalGetPendingReleaseEarmarkListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.approvalGetPendingReleaseEarmarkListingSuccess(response.data));
    }
}
